import { useTranslation } from 'react-i18next';
import { useGlobalStoreShallow } from 'src/store/globalStore';

/**
 * Returns the phrase used to name the reporting organisation inside reporter-facing
 * copy, e.g. "Acme Ltd (your organisation)".
 *
 * The tenant is not always resolved (a reporter can reach the flow before the company
 * has been looked up), so it falls back to a generic phrase rather than rendering an
 * empty name or a bare pair of brackets.
 */
export const useOrganisationLabel = () => {
    const { t } = useTranslation();
    const { companyInfo } = useGlobalStoreShallow(['companyInfo']);

    const tenantName = companyInfo?.name?.trim();

    return tenantName
        ? t('ORGANISATION_NAMED', { tenantName })
        : t('ORGANISATION_GENERIC');
};
